<template>
    <div>
        <div class="button noselect"
             v-on:click="clicked(hiddenKey)"
             v-on:keyup="onEnterKey"
            tabindex="0">
            <img src="@/assets/new.png">
        </div>
    </div>
</template>

<script>
    export default {
        name: "BBtnIconAdd",
        props: {
            imgSrc: String,
            btnTxt: String,
            clicked: Function,
            hiddenKey: String,
            lengthPx: Number,
            size: String,
        },
        data() {
            return {}
        },
        methods: {
            onEnterKey(event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    this.clicked(this.hiddenKey);
                }
            }
        },
    }
</script>

<style scoped>
    .button {
        display: flex;
        height: 38px;
        width: 38px;
        background: #0171A3;
        border-radius: 5px;
        color: #FEFEFE;
        justify-content: center;
        align-items: center;
        margin: 0 0.5em 0 0;
        cursor: pointer;
        font-size: 14px;
    }
    :focus {
        outline: none;
    }

    .button:hover,
    .button:focus {
        background: #018AC7;
    }

    .button:active {
        background: #025F89;
    }

    .button img {
        width: 18px;
        height: 18px;
    }

    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                         supported by Chrome and Opera */
    }
</style>